import { TOUCH_TARGET_PX } from 'theme/touchTarget';

export const optionRowSx = {
  '& .MuiFormControlLabel-root': {
    margin: 0,
    gap: '10px',
    paddingX: 0.5,
    paddingY: 0.75,
    borderRadius: 1,
    transition: 'background-color 120ms ease',
    '@media (hover: hover)': {
      '&:hover': { backgroundColor: 'highlight.neutral' },
    },
  },
  '& .MuiRadio-root': { padding: 0 },
  '@media (hover: none)': {
    '& .MuiFormControlLabel-root': { minHeight: TOUCH_TARGET_PX },
  },
};
